var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-messages" },
    [
      _vm.templateMessageModal && !_vm.isMetaFormat(_vm.templateMessageModal)
        ? _c("TemplateMessageModal", {
            attrs: {
              template: _vm.templateMessageModal,
              "channel-id": _vm.contact.channel,
            },
            on: {
              close: function ($event) {
                _vm.templateMessageModal = null
              },
              send: _vm.sendTemplate,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.templateMessageModal && _vm.isMetaFormat(_vm.templateMessageModal)
        ? _c("MetaTemplateMessageModal", {
            attrs: {
              template: _vm.templateMessageModal,
              channel: _vm.currentChannel,
            },
            on: {
              close: function ($event) {
                _vm.templateMessageModal = null
              },
              send: _vm.sendTemplate,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.channels.length === 0
        ? _c("div", { staticClass: "empty" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("auto.whatsappChannelNotFound"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.$t("auto.noWhatsappChannelFoundInSystem"))),
            ]),
          ])
        : [
            _c("div", { staticClass: "search-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                staticClass: "search-input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("auto.searchTemplate"),
                },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchTerm = $event.target.value
                    },
                    _vm.onSearchInput,
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items" },
              [
                _vm.filteredTemplates.length <= 0
                  ? _c("div", [_vm._v(_vm._s(_vm.$t("auto.templateNotFound")))])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.filteredTemplates, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item._id,
                      staticClass: "item-card",
                      class: {
                        selected: _vm.pointerIndex === index,
                        hoverSelected: _vm.pointerIndex === index,
                      },
                      attrs: { "data-id": item._id, "data-pointer": index },
                      on: {
                        click: function ($event) {
                          return _vm.useTemplate(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "title-wrapper" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getTemplateName(item)) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isMetaFormat(item)
                          ? _c(
                              "div",
                              {
                                staticClass: "status-badge",
                                class: _vm.getStatusClass(item),
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.getTemplateStatus(item)) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-preview" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getTemplateBody(item)) +
                            "\n                "
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }